require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./coding-interview-prep-rosetta-code-heronian-triangles.json") })
        }
      }, "path---coding-interview-prep-rosetta-code-heronian-triangles");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---coding-interview-prep-rosetta-code-heronian-triangles!./.cache/json/coding-interview-prep-rosetta-code-heronian-triangles.json
// module id = 1899
// module chunks = 231608221292675